import { PartialTranslation } from '../translations';

export const km: PartialTranslation = {
  newChat: 'ការជជែកថ្មី',
  search: 'ស្វែងរក',
  user: 'អ្នកប្រើប្រាស់',
  settings: 'ការកំណត់',
  language: 'ភាសា',
  getHelp: 'ទទួលបានជំនួយ',
  viewAllPlans: 'មើលផែនការទាំងអស់',
  learnMore: 'ស្វែងយល់បន្ថែម',
  logOut: 'ចាកចេញ',
  chooseLanguage: 'ជ្រើសរើសភាសា',
  chooseYourPreferredLanguage: 'ជ្រើសរើសភាសាដែលអ្នកចង់បាន',
  searchLanguages: 'ស្វែងរកភាសា...',
  autoDetect: 'ការរកឃើញដោយស្វ័យប្រវត្តិ',
  noLanguagesFound: 'រកមិនឃើញភាសាទេ',
  askAnything: 'សួរអ្វីក៏បាន',
  lawhelperAi: 'Lawhelper.ai',
  personal: 'ផ្ទាល់ខ្លួន',
  freePlan: 'ផែនការឥតគិតថ្លៃ',
  current: 'បច្ចុប្បន្ន',
  close: 'បិទ',
  archive: 'បណ្ណាល័យ',
  delete: 'លុប',
  confirmDelete: 'តើអ្នកពិតជាចង់លុបការជជែកនេះមែនទេ?',
  confirmArchive: 'តើអ្នកពិតជាចង់រក្សាទុកការជជែកនេះក្នុងបណ្ណាល័យមែនទេ?',
  deleteCannotUndo: 'សកម្មភាពនេះមិនអាចត្រឡប់វិញបានទេ។',
  archiveCanFind: 'អ្នកអាចរកឃើញវានៅក្នុងបញ្ជីបណ្ណាល័យបន្ទាប់ពីរក្សាទុកហើយ។',
  resources: 'ធនធាន',
  addResource: 'បន្ថែមធនធាន',
  deleteResource: 'លុបធនធាន',
  noMatchingResourcesFound: 'រកមិនឃើញធនធានដែលត្រូវគ្នាទេ',
  noResourcesAvailable: 'មិនមានធនធានដែលអាចប្រើបានទេ',
  hideResources: 'លាក់ធនធាន',
  showResources: 'បង្ហាញធនធាន',
  typeMessage: 'វាយសារ...',
  thinkingOptions: 'ជម្រើសនៃការគិត',
  deleteFile: 'លុបឯកសារ',
  clearSelection: 'សម្អាតការជ្រើសរើស',
  addAttachment: 'បន្ថែមឯកសារភ្ជាប់',
  sendMessage: 'ផ្ញើសារ',
  deepInsight: 'ការយល់ដឹងជ្រៅ · ការវិភាគផ្ទៃ',
  deepInsightDesc: 'ការយល់ដឹងរហ័សនៃចំណុចសំខាន់ៗ',
  deepExploration: 'ការស្វែងរកជ្រៅ · ការវិភាគដ៏ពេញលេញ',
  deepExplorationDesc: 'ការស្រាវជ្រាវជ្រៅពហុវិមាត្រ',
  deepDeconstruction: 'ការបំបែកជ្រៅ · ការបែងចែកតាមប្រព័ន្ធ',
  deepDeconstructionDesc: 'ការវិភាគស្រដៀងៗគ្នាតាមស្រទាប់',
  contractReview: 'ការពិនិត្យកិច្ចសន្យា · ការកំណត់ហេតុការណ៍ទ្រស្ត',
  contractReviewDesc: 'ការវិភាគលក្ខខណ្ឌនិងការត្រួតពិនិត្យអនុលោម',
  textPolish: 'ការកែសម្រួលអត្ថបទ · ការបញ្ចេញមតិប្រកបដោយវិជ្ជាជីវៈ',
  textPolishDesc: 'ការកែលម្អភាសានិងការរៀបចំរចនាសម្ព័ន្ធ',
  legalDocuments: 'ឯកសារ់ច្បាប់ · ការព្រាងសិល្បនីយកម្ម',
  legalDocumentsDesc: 'ការសរសេរឯកសារ់ច្បាប់ប្រកបដោយវិជ្ជាជីវៈ',

  // 认证和隐私翻译 (English fallback - needs translation)
  login: 'ចូល',
  register: 'ចុះឈ្មោះ',
  welcomeBack: 'សូមស្វាគមន៍មកកាន់ LawHelper',
  loginSubtitle: 'ជំនួយការស្រាវជ្រាវច្បាប់ AI របស់អ្នក',
  continueWithGoogle: 'បន្តជាមួយ Google',
  continueWithMicrosoft: 'បន្តជាមួយ Microsoft',
  continueWithWeChat: 'បន្តជាមួយ WeChat',
  orContinueWith: 'ឬបន្តជាមួយ',
  emailTab: 'អ៊ីមែល',
  phoneTab: 'ទូរស័ព្ទ',
  emailPlaceholder: 'បញ្ចូលអ៊ីមែលរបស់អ្នក',
  phonePlaceholder: 'បញ្ចូលលេខទូរស័ព្ទ',
  codePlaceholder: 'បញ្ចូលកូដ 6 ខ្ទង់',
  sending: 'កំពុងផ្ញើ...',
  verifying: 'កំពុងផ្ទៀងផ្ទាត់...',
  verify: 'ផ្ទៀងផ្ទាត់',
  sendMagicLink: 'ផ្ញើតំណវេទមន្ត',
  getVerificationCode: 'យកកូដ',
  resendCode: 'ផ្ញើកូដម្តងទៀត',
  resendIn: 'ផ្ញើម្តងទៀត',
  magicLinkSent: 'តំណវេទមន្តបានផ្ញើទៅអ៊ីមែលរបស់អ្នក',
  magicLinkHint: 'យើងនឹងផ្ញើតំណសុវត្ថិភាពទៅអ៊ីមែលរបស់អ្នក',
  otpSent: 'កូដផ្ទៀងផ្ទាត់បានផ្ញើ',
  agreeToTerms: 'តាមរយៈការបន្ត អ្នកយល់ព្រមជាមួយ',
  privacyPolicy: 'គោលការណ៍ភាពឯកជន',
  termsOfService: 'លក្ខខណ្ឌនៃសេវាកម្ម',
  and: 'និង',
  privacyTitle: 'ភាពឯកជនរបស់អ្នកមានសារៈសំខាន់',
  privacyIntro: 'យើងប្រើខូគីស និងបច្ចេកវិទ្យាស្រដៀងគ្នា ដើម្បីផ្តល់បទពិសោធន៍ល្អបំផុតដល់អ្នក។',
  essentialCookies: 'ខូគីសចាំបាច់',
  essentialDesc: 'ត្រូវការសម្រាប់គេហទំព័រដំណើរការ',
  analyticsCookies: 'ខូគីសវិភាគ',
  analyticsDesc: 'ជួយយើងកែលម្អសេវាកម្ម',
  marketingCookies: 'ខូគីសទីផ្សារ',
  marketingDesc: 'ប្រើសម្រាប់មាតិកាផ្ទាល់ខ្លួន',
  acceptAll: 'ទទួលយកទាំងអស់',
  essentialOnly: 'ចាំបាច់ប៉ុណ្ណោះ',
  customize: 'ប្ដូរតាមបំណង',
  savePreferences: 'រក្សាទុកចំណូលចិត្ត',
  back: 'ថយក្រោយ',
  readPrivacyPolicy: 'អានគោលការណ៍ភាពឯកជនរបស់យើង',
  cookiePolicy: 'គោលការណ៍ខូគីស',
  gdprCompliance: 'GDPR',
  piplCompliance: 'PIPL',

  // AI工具面板
  aiReview: 'ពិនិត្យ AI',
  aiDraft: 'សេចក្តីព្រាង AI',
  smartAssistant: 'គំរូ',

  // 知识库搜索
  enableKnowledgeSearch: 'បើកការស្វែងរក',
  knowledgeSearchDesc: 'AI ស្វែងរកក្នុងឯកសារ',
  clickToDisable: 'បិទ',
  clickToEnable: 'បើក',

  // Landing page translations
  tagline: 'AI-Powered Legal Intelligence',
  heroTitle1: 'Legal AI',
  heroTitle2: 'Simplified.',
  jurisdictionsLabel: 'Jurisdictions',
  accuracyLabel: 'Accuracy',
  fasterLabel: 'Faster',
  availableLabel: 'Available',
  platformCapabilities: 'Platform Capabilities',
  testimonialQuote: '"LawHelper has transformed how we handle legal work. Contract review is 10x faster, with incredible accuracy."',
  testimonialAuthor: 'Legal Professional',
  testimonialPosition: 'Partner at Top Law Firm',
  viewPricing: 'View Pricing',
  footerPricing: 'Pricing',
  footerPrivacy: 'Privacy',
  footerTerms: 'Terms',
  footerContact: 'Contact',
  footerCopyright: '© 2024 LawHelper. All rights reserved.',

  // Onboarding Guide
  onboardingWelcome: 'Welcome to Lawhelper.ai',
  onboardingSkip: 'Skip',
  onboardingNext: 'Next',
  onboardingPrev: 'Back',
  onboardingGetStarted: 'Get Started',
  onboardingSlide1Title: 'AI Legal Chat',
  onboardingSlide1Desc: 'Ask any legal question and get precise, jurisdiction-aware answers powered by advanced AI.',
  onboardingSlide2Title: 'Case Folder System',
  onboardingSlide2Desc: 'Organize your documents by case. Upload files and control which materials AI uses as context.',
  onboardingSlide3Title: 'Local Folder Access',
  onboardingSlide3Desc: 'Connect local directories in the browser. Preview, edit, and send files to AI chat.',
  onboardingSlide4Title: 'AI Drafting & Review',
  onboardingSlide4Desc: 'Draft legal documents with AI and review contracts to identify risks automatically.',
  onboardingGuide: 'Guide',
  mentionFiles: "Reference a file",

  // Auto-synced keys
  chats: 'Chats',
  archived: 'Archived',
  restore: 'Restore',
  noArchivedChats: 'No archived chats',
  backToChats: 'Back to Chats',
  closeResourcesPanel: 'Close Resources Panel',
  uploading: 'Uploading %{fileName}...',
  processing: 'Processing %{fileName}...',
  uploadSuccess: '✓ %{fileName} uploaded successfully',
  uploadError: '✗ Upload failed: %{error}',
  quickAnswer: 'ចម្លើយស្រែច',
  quickAnswerDesc: 'Fast response for simple questions',
  cancelRequest: 'លុបចោល',
  library: 'ប្រជុំសៀវភៅ',
  filterAll: 'ទាំងអស់',
  filterChat: 'Chats',
  filterReview: 'Review',
  filterDraft: 'Draft',
  filterTemplate: 'Template',
  filterForm: 'Form',
  thinking: 'កំពុងគិត...',
  thinkingProcess: 'Thinking Process',
  analyzingLegalLogic: 'Analyzing legal logic...',
  lawhelperThinking: 'Lawhelper is thinking...',
  serviceError: 'Service Error',
  uploaded: 'Uploaded',
  settingsGeneral: 'ទូទៅ',
  settingsNotifications: 'Notifications',
  settingsAppearance: 'Appearance',
  settingsProfile: 'Profile',
  settingsResponseNotifications: 'Response Notifications',
  settingsResponseNotificationsDesc: 'Get notified when AI finishes a response',
  settingsColorMode: 'Color Mode',
  settingsLight: 'Light',
  settingsDark: 'Dark',
  settingsSystem: 'System',
  about: 'អំពី',
  reviewTitle: 'Document Review',
  exitReview: 'Exit Review',
  uploadPrompt: 'Upload PDF to start review',
  uploadButton: 'Select File',
  startChatConfig: 'Type "Review this document" to start',
  reviewPlaceholder: 'Type a message or "Review this document"...',
  analyzing: 'Reviewing...',
  reviewComplete: 'Review Complete',
  issuesFound: 'Found %{count} issues',
  draftTitle: 'Legal Document Drafting',
  draftPlaceholder: 'Edit here or ask AI to generate...',
  analyzingTemplate: 'Analyzing template file %{name}...',
  templateAnalyzed: '✅ Template %{name} analyzed! Tell me how you want to modify or fill this template.',
  templateAnalysisPrompt: 'Analyze key clauses of this template',
  parsingFailed: '⚠️ Failed to parse file, but you can still describe your needs.',
  generating: 'Generating...',
  generatedSuccess: '✅ Document generated! You can view and edit in the editor.',
  drafterWelcome: 'Welcome to AI Document Assistant',
  drafterYouCan: 'You can:',
  drafterUploadTemplate: 'Upload a template for AI to analyze',
  drafterDescribeNeeds: 'Describe your document requirements',
  drafterLetAiHelp: 'Let AI help you draft contracts, agreements, etc.',
  drafterExamples: 'Examples:',
  drafterExampleRental: '"Help me draft a rental agreement"',
  drafterExampleLabor: '"Fill in the labor contract based on template"',
  drafterInputPlaceholder: 'Describe your document needs...',
  drafterThinking: 'Thinking...',
  drafterHistoryTitle: 'History',
  drafterNoHistory: 'No history yet',
  drafterNewChat: 'New Chat',
  drafterHistory: 'History',
  drafterRemoveAttachment: 'Remove attachment',
  drafterLineHeight: 'Line Height',
  drafterLineHeightSuffix: 'x',
  drafterExportWord: 'Export as Word (.docx)',
  drafterExportPdf: 'Export as PDF',
  drafterSave: 'Save Document',
  drafterDownload: 'Download Document',
  drafterUndo: 'Undo',
  drafterRedo: 'Redo',
  drafterBold: 'Bold',
  drafterItalic: 'Italic',
  drafterStrike: 'Strikethrough',
  drafterUnderline: 'Underline',
  drafterHighlight: 'Highlight',
  drafterLink: 'Insert Link',
  drafterAlignLeft: 'Align Left',
  drafterAlignCenter: 'Align Center',
  drafterAlignRight: 'Align Right',
  drafterAlignJustify: 'Justify',
  drafterList: 'List',
  drafterBulletList: 'Bullet List',
  drafterOrderedList: 'Ordered List',
  drafterTaskList: 'Task List',
  drafterOpenResource: 'Open Resources Panel',
  drafterStopGeneration: 'Stop generation',
  drafterAgentMode: 'Agent mode enabled | Click to switch to normal chat',
  drafterAgentModeOn: 'Agent mode enabled | Click to switch to normal chat',
  drafterAgentModeOff: 'Normal chat mode | Click to switch to Agent mode',
  drafterUploadAttachment: 'Upload attachment',
  drafterExit: 'Exit',
  drafterConfirm: 'Confirm',
  drafterOpenLink: 'Open link',
  drafterDeleteLink: 'Delete link',
  drafterQuote: 'Quote',
  workflowTitle: 'AI Workflow',
  workflowRunning: 'Running...',
  workflowReady: 'Ready',
  workflowCompleted: 'Completed',
  workflowStartFailed: 'Workflow start failed',
  workflowExecutionFailed: 'Workflow execution failed',
  workflowInterrupted: 'Workflow interrupted',
  workflowProcessing: 'Processing...',
  workflowStepsCompleted: 'steps completed',
  workflowStepsTotal: 'Workflow completed (%{count} steps)',
  acceptChanges: 'Accept Changes',
  rejectChanges: 'Reject Changes',
  changesAccepted: 'Changes accepted',
  changesRejected: 'Changes rejected',
  stopWorkflow: 'Stop',
  restartWorkflow: 'Restart',
  startDrafting: 'Start Drafting',
  interrupt: 'Stop',
  documentSubject: 'Document Subject *',
  documentType: 'Document Type',
  jurisdiction: 'Jurisdiction',
  specialRequirements: 'Special Requirements (optional)',
  clickStartDrafting: 'Click "Start Drafting" to begin workflow',
  docTypeContract: 'Contract',
  docTypeAgreement: 'Agreement',
  docTypeNotice: 'Notice',
  docTypeLetter: 'Letter',
  docTypePetition: 'Petition',
  docTypeWill: 'Will',
  docTypePowerOfAttorney: 'Power of Attorney',
  countryChina: 'China',
  countryUSA: 'United States',
  countryGermany: 'Germany',
  countryJapan: 'Japan',
  countryFrance: 'France',
  countryUK: 'United Kingdom',
  citationVerified: 'Verified',
  citationUnverified: 'Unverified',
  imageLoadFailed: 'Image failed to load',
  smartDocTitle: 'ឧបករណ៍ឯកសារឆ្លាត',
  smartDocChatTitle: 'AI Document Assistant',
  smartDocDropPrompt: 'Drop PDF file here',
  smartDocSelectFile: 'Select File',
  smartDocOr: 'or',
  smartDocWelcomeTitle: 'Welcome to AI Document Assistant',
  smartDocWelcomeYouCan: 'You can:',
  smartDocUploadForAI: 'Upload a template for AI to analyze',
  smartDocDescribeDoc: 'Describe your document requirements',
  smartDocLetAIDraft: 'Let AI help you draft contracts, agreements, etc.',
  smartDocExamples: 'Examples:',
  smartDocExampleRental: '"Help me draft a rental agreement"',
  smartDocExampleLabor: '"Fill in the labor contract based on template"',
  smartDocInputPlaceholder: 'Describe your document needs...',
  smartDocRemoveAttachment: 'Remove attachment',
  smartDocOpenResources: 'Open Resources Panel',
  smartDocExit: 'Exit',
  reviewStartFailed: 'Review workflow start failed',
  reviewFailed: 'Review failed',
  reviewFoundIssues: 'Review complete, found %{count} issues.',
  cannotReadStream: 'Cannot read response stream',
  parseEventFailed: 'Failed to parse workflow event',
  errorPrefix: 'កំហុស',
  unknownError: 'Unknown error',
  file: 'ឯកសារ',
  loading: 'កំពុងតែ...',
  localFolders: 'Local Folders',
  selectLocalFolder: 'Select Local Folder',
  reselectFolder: 'Change Folder',
  addToContext: 'Add to Chat',
  saveFile: 'Save',
  renameFile: 'Rename',
  fileSaved: 'File saved successfully',
  fileRenamed: 'File renamed to %{name}',
  browserNotSupported: 'Your browser does not support local folder access',
  noFolderSelected: 'Select a local folder to browse files',
  scanningFolder: 'Scanning folder...',
  selectFileToPreview: 'Select a file to preview',
  aiAnalyze: 'វិភាគ AI',
};
